import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { List, Map } from 'immutable';
import { Observable } from 'rxjs';
import { Dashboard } from '../reports/models/dashboard.model';
import { ReportType } from '../reports/models/report-type.model';
import {
  getCurrentReport,
  getCurrentReportFilterValues,
  getCurrentReportType,
  getDashboard,
  getDashboardFetched,
  getExpandedSummaryItems,
  getFetchDashboardError,
  getFetchReportError,
  getHomeMetrics,
  getHomeMetricsError,
  getReportFetched,
  getReportTypes,
} from './report-data.reducer';
import { HomeMetrics } from './models/home-metrics.model';
import { ReportExpandedViewTypesEnum } from './report-data.data';
import { filter, map } from 'rxjs/operators';
import { ExpandedSummary } from './models/expanded-summary.model';
import { ExpandedViewItem } from './models/sub-models/expanded-view-item.model';

@Injectable()
export class ReportDataStore {
  constructor(private _store: Store<any>) {}

  getDashboardFetched(): Observable<boolean> {
    return this._store.select(getDashboardFetched);
  }

  getDashboard(): Observable<Dashboard> {
    return this._store.select(getDashboard);
  }

  getCurrentReportType(): Observable<ReportType> {
    return this._store.select(getCurrentReportType);
  }

  getCurrentReportFilterValues(): Observable<any> {
    return this._store.select(getCurrentReportFilterValues);
  }

  getFetchDashboardError(): Observable<any[]> {
    return this._store.select(getFetchDashboardError);
  }

  getReportTypes(): Observable<List<ReportType>> {
    return this._store.select(getReportTypes);
  }

  getFetchReportError(): Observable<any[]> {
    return this._store.select(getFetchReportError);
  }

  getReportFetched() {
    return this._store.select(getReportFetched);
  }

  getCurrentReport() {
    return this._store.select(getCurrentReport);
  }

  getHomeMetrics(): Observable<HomeMetrics> {
    return this._store.select(getHomeMetrics);
  }

  getHomeMetricsError(): Observable<any[]> {
    return this._store.select(getHomeMetricsError);
  }

  getExpandedSummaryDataByType(
    type: ReportExpandedViewTypesEnum
  ): Observable<ExpandedSummary> {
    return this._store.pipe(
      select(getExpandedSummaryItems),
      map((expandedSummaryItems: Map<string, ExpandedSummary>) =>
        expandedSummaryItems.get(type)
      )
    );
  }

  getExpandedViewItemsByType(
    type: ReportExpandedViewTypesEnum
  ): Observable<List<ExpandedViewItem>> {
    return this._store.pipe(
      select(getExpandedSummaryItems),
      map((expandedSummaryItems: Map<string, ExpandedSummary>) =>
        expandedSummaryItems.get(type)
      ),
      filter((x) => !!x),
      map((summaryData: ExpandedSummary) => {
        /**
         * Sort graph in descending order, list in ascending order
         */
        const sortOrder = summaryData.barGraph ? -1 : 1;

        return summaryData.items
          .sortBy((item: ExpandedViewItem) => sortOrder * item.rank)
          .toList();
      })
    );
  }
}
